module.exports = __webpack_public_path__ + "img/C4DEDE_97B5B5_EAF9F9_ABC4C4-256px.a8b92251.png";